import axiosClient from './client'

export const confirmTithe = id => axiosClient().put(`/tithes/${id}/confirm`)
export const destroyTithe = id => axiosClient().delete(`/tithes/${id}`)
